import Constants from '@Apis/constants';
import Helpers from '@Apis/helpers';
/**
 * MemberServices class
 *
 * @param callback
 * @param payload
 */
class MemberServices {
    /**
     *
     * @return {Promise<*>}
     */
    getMembers = async () => {
      const members = Helpers.get({
        url: `${Constants.MEMBERS}?`,
      });
      return members;
    }

    /**
     *
     * @param payload
     * @return {Promise<*>}
     */
    createMember = async (payload) => {
      const createdMember = Helpers.post({
        url: Constants.MEMBERS,
        data: payload,
      });
      return createdMember;
    }

    /**
     *
     * @param payload
     * @return {Promise<*>}
     */
   updateMember = async (payload) => {
     const createdMember = Helpers.put({
       url: Constants.MEMBERS,
       data: payload,
     });
     return createdMember;
   }

    /**
     *
     * @param deleteMemberId
     * @return {Promise<void>}
     */
    deleteMember = async (payload) => {
      const deletedMember = Helpers.delete({
        url: `${Constants.MEMBERS}?`,
        data: payload,
      });
      return deletedMember;
    }

    /**
     *
     * @return {Promise<*>}
     */
     getTenantsRoles = async () => {
       const tenantsRoles = Helpers.get({
         url: `${Constants.MEMBERS}/editPage?`,
       });
       return tenantsRoles;
     }
}

export default new MemberServices();